import React from 'react';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

/**
 * Reusable confirmation modal with danger/warning styling.
 *
 * Props:
 *  - open: boolean
 *  - title: string
 *  - message: string (supports line breaks via \n)
 *  - confirmLabel: string (default "Confirm")
 *  - cancelLabel: string (default "Cancel")
 *  - variant: 'danger' | 'warning' (default 'danger')
 *  - onConfirm: () => void
 *  - onCancel: () => void
 *  - loading: boolean
 */
export default function ConfirmModal({
  open,
  title = 'Are you sure?',
  message = '',
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'danger',
  onConfirm,
  onCancel,
  loading = false,
}) {
  if (!open) return null;

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div className={`confirm-modal confirm-modal--${variant}`} onClick={(e) => e.stopPropagation()}>
        <button className="confirm-modal-close" onClick={onCancel} aria-label="Close">
          <FiX />
        </button>

        <div className="confirm-modal-icon">
          <FiAlertTriangle />
        </div>

        <h3 className="confirm-modal-title">{title}</h3>

        {message && (
          <p className="confirm-modal-message">
            {message.split('\n').map((line, i) => (
              <span key={i}>{line}{i < message.split('\n').length - 1 && <br />}</span>
            ))}
          </p>
        )}

        <div className="confirm-modal-actions">
          <button
            className="confirm-modal-btn cancel"
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            className={`confirm-modal-btn confirm confirm-modal-btn--${variant}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
